module.exports = __webpack_public_path__ + "static/media/bindQQ2.41999c58.png";